import type {CurrencyType, SocialLinkType} from "@/types";
import {Facebook, Instagram, Twitter, Linkedin} from "lucide-vue-next";

//import favicon from '@/assets/images/favicon.ico'
import favicon from '@/assets/images/favicon.png'
export const appName: string = 'AnyMic'
export const appTitle: string = 'AnyMic - Your Voice Matters'
export const appDescription: string = ''
export const appAuthor: string = 'entrepre.nerds'
export const appAuthorWebsite: string = 'https://entre.prenerds.com'

export const buyLink: string = ''

export const currentYear: number = new Date().getFullYear()

export const currency: CurrencyType = '€'

export {favicon}

export const socialLinks: SocialLinkType[] = [
    {
        icon: Facebook,
        route: {url: ''}
    },
    {
        icon: Instagram,
        route: {url: ''}
    },
    {
        icon: Twitter,
        route: {url: ''}
    },
    {
        icon: Linkedin,
        route: {url: ''}
    },
]
